const initialState = {
	zones: null
};
/**
 * Reducer managing contingent.
 *
 * @name ZoneReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	if (!action.isAction) {
		return state;
	}
	return action.performZoneReducer(state);
};
